import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { IBaseInventoryItem } from '../inventory-base-meal-item/types';
import styles from './styles.module.css';
import { Input } from '@cokitchen/cokitchen-components';
import { ReactComponent as SearchIcon } from '../../header/icons/search.svg';
import InventoryBaseMealItem from '../inventory-base-meal-item';

type Props = {
  category: any;
  brandName: string;
};

const InventoryBaseMealCategory: FC<Props> = ({ category, brandName }) => {
  // eslint-disable-next-line
  const [unavailableMealsCount, setUnavailableMealsCount] = useState(0);
  // eslint-disable-next-line
  const [mealAltered, setMealAltered] = useState(false);
  const [allMealItems, setAllMealItems] = useState<IBaseInventoryItem[]>([]);
  const [mealItems, setMealItems] = useState<IBaseInventoryItem[]>([]);
  const [search, setSearch] = useState('');

  const attachKeyToMeal = (meal: IBaseInventoryItem) => {
    meal.key = meal.id;
    return meal;
  };

  const attachKeyToMeals = (meals: IBaseInventoryItem[]) =>
    meals?.map((meal) => attachKeyToMeal(meal));

  useEffect(() => {
    setAllMealItems(attachKeyToMeals(category));
  }, [category]);

  useEffect(() => {
    if (allMealItems) {
      setUnavailableMealsCount(
        allMealItems?.filter((item) => Number(item.quantity).toFixed(0) === '0').length
      );
      filterMealItems();
    }
  }, [allMealItems]);

  useEffect(() => {
    filterMealItems();
  }, [search]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const value = e.target.value;
    setSearch(value.toUpperCase());
    filterMealItems();
  };

  const filterMealItems = () => {
    const filtered = allMealItems?.filter(({ base_meal }) =>
      base_meal?.name?.toUpperCase()?.includes(search)
    );
    setMealItems(attachKeyToMeals(filtered));
  };

  return (
    <div className={styles.main}>
      <div className={styles.header}>
        <div className={styles.mainTitle}>
          <div>
            {brandName} {mealAltered ? '*' : ''}
          </div>
          <div>{category?.length} total items </div>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.stickyTop}>
          <div>
            <Input
              className='w-full'
              autoFocus
              value={search}
              placeholder='Search for base meal items'
              type='search'
              small
              onChange={handleSearch}
            />
          </div>
        </div>

        <div>
          {mealItems?.map((mealItem) => (
            <InventoryBaseMealItem key={mealItem.key} meal={mealItem} />
          ))}
          {mealItems?.length === 0 && search !== '' && (
            <p className='mt-[50px] text-center text-xl  text-gray-5'>
              <span>
                <SearchIcon className='mx-auto w-[30px] h-[30px]' />
              </span>
              There are no meal items for <span className='text-gray-6'>{`"${search}"`}</span>. You
              may want to check your spelling
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default InventoryBaseMealCategory;
